function useCounterState(textValue, maxLength, showCounterError) {
    const length = `${textValue}`.length;
    const isCounterError = showCounterError && length > maxLength;
    return { length, isCounterError };
}

export { useCounterState };
